import React, { Component } from 'react';
import { connect } from 'react-redux';

import { selectPaymentMethodAlterStage } from '../../../../actions/purchaseActions';

import getPixInput from './inputs/getPixInput';
import getBoletoInput from './inputs/getBoletoInput';
import getCreditCardInput from './inputs/getCreditCardInput';

const selectMethodPayment = (index, paymentMethod, props) => {
  if (paymentMethod === 'credit-card') {
    props.selectPaymentMethodAlterStage(3, 'stepDisplayCreditCard', 3);
    props.selectPaymentMethod(index);
  } else if (paymentMethod === 'boleto') {
    props.selectPaymentMethodAlterStage(1, 'stepDisplayBoleto');
    props.selectPaymentMethod(index);
  } else if (paymentMethod === 'safetypay') {
    props.selectPaymentMethodAlterStage(1, 'stepDisplayCashTransfer');
    props.selectPaymentMethod(index);
  } else if (paymentMethod === 'pix') {
    props.selectPaymentMethodAlterStage(1, 'stepDisplayPix');
    props.selectPaymentMethod(index);
  }
};

class PaymentMethodMobile extends Component {
  state = {
    activePayment: false,
  };

  componentWillMount(props) {
    const today = new Date();
    const deadline = today.addDays(1);
    const year = deadline.getUTCFullYear();
    const month = (deadline.getUTCMonth() + 1).toLocaleString('pt-BR', { minimumIntegerDigits: 2 });
    const day = deadline.getUTCDate().toLocaleString('pt-BR', { minimumIntegerDigits: 2 });
    this.deadline = `${day}/${month}/${year}`;
  }

  render() {
    if (!this.props.plan[0]) return <div />;

    const plan = this.props.plan[0];

    if (this.props.brands.length !== 0) {
      this.parcels = this.props.brands.reduce(function (prev, current) {
        return prev.parcels > current.parcels ? prev : current;
      });
    }

    const payments = [];

    this.props.paymentMethods.sort((a, b) =>
      a.displayOrder > b.displayOrder ? 1 : b.displayOrder > a.displayOrder ? -1 : 0
    );

    for (let i = 0; i < this.props.paymentMethods.length; i++) {
      if (this.props.paymentMethods[i].active) {
        if (this.props.paymentMethods[i].slug === 'credit-card')
          payments.push(getCreditCardInput(this.props, plan, this.parcels, selectMethodPayment, i));
        else if (this.props.paymentMethods[i].slug === 'boleto') payments.push(getBoletoInput(this.props, plan, selectMethodPayment, i));
        else if (this.props.paymentMethods[i].slug === 'pix')
          payments.push(getPixInput(this.props, plan, selectMethodPayment, i));
      }
    }

    return (
      <ul
        className="lista-opcoes-pagamento mobile"
        style={{ display: this.props.stagePurchase !== 2 && this.props.mobile ? 'none' : 'flex' }}
      >
        {payments}
      </ul>
    );
  }
}

export default connect(
  (state) => ({
    paymentMethods: state.purchase.paymentMethods,
    purchaseSummary: state.purchase.purchaseSummary,
    couponInfo: state.purchase.coupon,
    stagePurchase: state.purchase.stagePurchase,
    plan: state.search.plans,
    brands: state.purchase.creditCard.brands,
  }),
  {
    selectPaymentMethodAlterStage,
  }
)(PaymentMethodMobile);



// WEBPACK FOOTER //
// ./src/components/purchase/payment_info/mobile/PaymentMethodMobile.jsx